import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../scss/login.scss";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState({});
  const [errorValue, setErrorValue] = useState(false);
  const navigate = useNavigate();
  const url = process.env.REACT_APP_BASE_URL;

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${url}/login`, { username, password });
      const token = response.data.token;
      const type = response.data.type;

      if (token && type !== 'kitchen') {
        sessionStorage.setItem("token", token);
        sessionStorage.setItem("user", username);
        sessionStorage.setItem('type', type);
        navigate("/bill");
      } else {
        sessionStorage.setItem("token", token);
        sessionStorage.setItem("user", username);
        sessionStorage.setItem('type', type);
        navigate("/home");
      }
    } catch (error) {
      setError(error.response?.data || {});
      setErrorValue(true);
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem("token")) {
      navigate("/bill");
    }
  }, [navigate]);

  return (
    <div className="bg-login">
      <div className="bg-form-img"></div>
      <form>
        <div className="img-logo">
          <img src="./logo.jpg" alt="logo" className="logo" />
        </div>

        <label>Username</label>
        <input
          type="text"
          placeholder="Email or Phone"
          id="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="username"
        />

        <label>Password</label>
        <input
          type="password"
          placeholder="Password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="password"
        />

        <button className="btn-login" onClick={handleLogin}>
          Log In
        </button>

        {errorValue && <p className="error">{error.error}</p>}
      </form>
    </div>
  );
};

export default Login;